import React from "react";
import { ExpenseRateSheet } from "~/gql/types";
import { RateSheetsSearch } from "~/visuals/organisms/RateSheets";

const ExpenseRateSheets: React.FC<{
  rateSheets: ExpenseRateSheet[];
}> = ({ rateSheets }) => (
  <RateSheetsSearch {...{ rateSheets, type: "Expense" }} />
);

export default ExpenseRateSheets;
